import styled from 'styled-components';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { passportIdentityDocument } from '../../../../../../../../translations';

import { IdentityDocumentOverrideMonit } from './IdentityDocumentOverrideMonit';
import { PassportIdentityDocumentEnterForm } from './PassportIdentityDocumentEnterForm';
import { PassportIdentityDocumentEnterModalConfirmButton } from './PassportIdentityDocumentEnterModalConfirmButton';

type OnIdentityDocumentEntered = (patient: Patient) => Promise<void>;

const StyledPassportIdentityDocumentEnterModalContent = styled.div`
   display: flex;
   flex-direction: column;
   gap: 24px;
`;

StyledPassportIdentityDocumentEnterModalContent.displayName = 'StyledPassportIdentityDocumentEnterModalContent';

type PassportIdentityDocumentEnterModalProps = {
   readonly patientId: number;
   readonly hasAnotherIdentityDocument: boolean;
   readonly onCancel: VoidFunction;
   readonly onSuccess: VoidFunction;
   readonly onIdentityDocumentEntered: OnIdentityDocumentEntered;
};

export const PassportIdentityDocumentEnterModal = (props: PassportIdentityDocumentEnterModalProps): JSX.Element => {
   return (
      <Modal
         testId={'patientExternalIdentifierTypeStillValid'}
         title={passportIdentityDocument.enter.modal.title}
         width={ModalWidth.WIDE}
      >
         <StyledPassportIdentityDocumentEnterModalContent>
            {props.hasAnotherIdentityDocument ? <IdentityDocumentOverrideMonit /> : null}
            <PassportIdentityDocumentEnterForm>
               {({ handleSubmit, formState }) => (
                  <>
                     <PassportIdentityDocumentEnterModalConfirmButton
                        patientId={props.patientId}
                        handleSubmit={handleSubmit}
                        onIdentityDocumentEntered={props.onIdentityDocumentEntered}
                        onSuccess={props.onSuccess}
                     />

                     <ModalCancelButton
                        label={commonTranslationKeys.cancel}
                        onClick={props.onCancel}
                        shouldConfirmExit={formState.isDirty}
                     />
                     <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
            </PassportIdentityDocumentEnterForm>
         </StyledPassportIdentityDocumentEnterModalContent>
      </Modal>
   );
};
